import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const textInputViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map